import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {GridValueChangeEvent} from '@shared/models/common.models';
import {FileStoreCommonService} from '@features/file-manager/services/file-store-common.service';
import {PlatformCommand} from '@shared/commands/command-base';
import {MatAccordion} from '@angular/material/expansion';
import {MagicLinkModel} from '@shared/models/platform-tool-models';
import {ItpDesktopService} from '@core/services/itpdesktopservices/itp-desktop.service';
import {ItpDesktopUtilityService} from '@core/services/itpdesktopservices/itp-desktop-utility.service';


@Component({
    standalone: false,
    selector: 'app-file-store-expansion-panel',
  templateUrl: './file-store-expansion-panel.component.html',
  styleUrls: ['./file-store-expansion-panel.component.scss']
})
export class FileStoreExpansionPanelComponent implements OnInit {
  @Input() magicLinkModel: MagicLinkModel;
  showRecentPanel = true;
  showStarredPanel = true;
  api = 'FileStoreApi';
  invalidateSubject = new InvalidateSubject();
  @ViewChild(MatAccordion, {static: true}) accordion: MatAccordion;

  constructor(private fileStoreCommonService: FileStoreCommonService,
              private itpDesktopService: ItpDesktopService,
              private itpDesktopUtilityService: ItpDesktopUtilityService) {
  }

  ngOnInit(): void {
    this.accordion.openAll();
  }

  onSelectionChanged($event: GridValueChangeEvent) {

  }

  onGridCellValueChange($event: GridValueChangeEvent) {
    switch ($event.fieldSection.id) {
      case 'recentdirectoryentry':
        this.handleGridValueChange($event);
        break;
      case 'starreddirectoryentry':
        this.handleGridValueChange($event);
        break;
    }
  }

  private handleGridValueChange($event: GridValueChangeEvent) {
    if ($event.action) {
      this.handleActions($event);
    } else {
      if ($event.fieldDefinition && $event.fieldDefinition.key === 'Name') {
        if ($event.item.cells['IsDrive'] && $event.item.cells['IsDrive'].value) {
          this.openDrive($event);
        } else if ($event.item.cells['IsFolder'].value) {
          this.openFolder($event);
        } else {
          this.openFile($event);
        }
      }
    }
  }

  private handleActions($event: GridValueChangeEvent) {
    switch ($event.action.id) {
      case 'ZipDownload':
        this.fileStoreCommonService.downloadAsZip([{itemId: $event.item.id}]);
        break;
      case 'Download':
        this.fileStoreCommonService.downloadFile($event.item.id);
        break;
      case 'MarkStar':
        this.markStar($event);
        break;
      case 'Open':
        switch ($event.item.cells['IsFolder'].value) {
          case true:
            this.openFolder($event);
            break;
          case false:
            this.openFile($event);
            break;
        }
        break;
    }
  }

  private openFile($event: GridValueChangeEvent) {
    if (this.itpDesktopService.isDesktop() && !this.itpDesktopUtilityService.doOpenFile($event.item.cells['SafeName'].value))  {
      const param = this.itpDesktopUtilityService.createParamForOpenFileListView($event.item);
      this.itpDesktopService.cefSharpPost('openFile', param);
    } else {
      const command = new PlatformCommand('OpenFileCommand', 'FileStoreApi');
      command.fieldValues['ItemId'] = $event.item.id;
      command.fieldValues['IsClientDrive'] = true;
      this.fileStoreCommonService.openFile(command);
    }
  }

  private openFolder($event: GridValueChangeEvent) {
    const command = new PlatformCommand('OpenFolderCommand', 'FileStoreApi');
    command.fieldValues['DriveId'] = $event.item.cells['DriveId'].value;
    command.fieldValues['IsClientDrive'] = true;
    command.fieldValues['ItemId'] = $event.item.id;
    command.fieldValues['ViewType'] = 'GridView';
    this.fileStoreCommonService.openFolder(command);
  }

  private openDrive($event: GridValueChangeEvent) {
    const command = new PlatformCommand('OpenFolderCommand', 'FileStoreApi');
    command.fieldValues['DriveId'] = $event.item.cells['DriveId'].value;
    command.fieldValues['ViewType'] = 'GridView';
    this.fileStoreCommonService.openDrive(command);
  }

  private markStar(event: GridValueChangeEvent): void {
    console.log('contextMenuItem', event);
    const command = new PlatformCommand('ToggleStarContentCommand', 'FileStoreApi');
    command.fieldValues['ItemId'] = event.item.id;
    command.fieldValues['IsDeleted'] = false;
    command.fieldValues['IsClientDrive'] = event.item.cells['IsClientDrive'].value;
    command.fieldValues['IsFavorite'] = event.item.cells['IsFavorite'].value;
    command.fieldValues['ParentId'] = event.item.cells['ParentId'].value;
    command.fieldValues['Type'] = event.item.cells['Type'].value;
    this.fileStoreCommonService.executeCommand(command).subscribe(res => {
      this.invalidateSubject.invalidate();
    });
  }
}
